import React, { useState, useEffect } from 'react';
import config from '../../config/config';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './css/header.css';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { NavDropdown } from 'react-bootstrap';
import ModalDeck from '../home/modalDeck';

const Header = () => {
  const [scrollHeader, setScrollHeader] = useState(false);
  const [activeMenu, setActiveMenu] = useState('#action1'); // Default active menu item
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const { isConnected, address, chainId, isDisconnected, chain } = useAccount();
  const { open } = useWeb3Modal();
  // -----------
  const [show, setShow] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrollHeader(true); // Add a class when scrolled down
    } else {
      setScrollHeader(false); // Remove the class when at the top
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleMenuClick = (menuId) => {
    setActiveMenu(menuId); // Update the active menu item
  };

  const handleConnectWallet = (e) => {
    e.preventDefault();
    try {
      open();
    } catch (error) {
      console.log('Err', error);
    }
  };

  const handleDeck = (e) => {
    e.preventDefault();
    try {
      window.location.href = 'https://docsend.com/v/khq29/deck';
    } catch (error) {
      console.log('Err', error);
    }
  };

  return (
    <>
      <div className={scrollHeader ? 'header scroll-header' : 'header'}>
        {['xl'].map((expand) => (
          <Navbar key={expand} expand={expand} className="">
            <Container>
              <Navbar.Brand href="#">
                <Link to={`${config.baseUrl}`}>
                  <img src="assets/images/logo/logo.png" alt="Logo" />
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle
                aria-controls={`offcanvasNavbar-expand-${expand}`}
              />
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img
                      src="assets/images/logo/logo.png"
                      width={`200`}
                      alt="Logo"
                    />
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-center flex-grow-1">
                    <NavDropdown
                      title="Learn"
                      id="basic-nav-dropdown"
                      className="customDropdown"
                    >
                      <div className="d-xl-flex justify-content-between p-2 gap-3">
                        <div className="menuBoxImg ">
                          <div className="megaImg">
                            <img src="assets/images/megamenu/m.png" alt="" />
                          </div>
                        </div>
                        <div className="menuContent">
                          <div className="d-flex gap-3">
                            <div className="menuBox ">
                              <NavDropdown.Item
                                href={`${config.baseUrl}unitronixexplained`}
                              >
                                Unitronix Explained
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${config.baseUrl}ourstrategy`}
                              >
                                Our Strategy
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${config.baseUrl}empowerfeature`}
                              >
                                Empowering Features
                              </NavDropdown.Item>
                              <NavDropdown.Divider />
                            </div>
                            <div className="menuBox ">
                              <NavDropdown.Item
                                href={`${config.baseUrl}roadmap`}
                              >
                                Roadmap
                              </NavDropdown.Item>
                              <NavDropdown.Item onClick={() => setShow(true)}>
                                Deck
                              </NavDropdown.Item>
                              <NavDropdown.Item href="">
                                White Paper
                                <div>
                                  <span class="text-grey x-small">
                                    (Coming Soon)
                                  </span>
                                </div>
                              </NavDropdown.Item>
                            </div>
                          </div>

                          <div className="megafooter px-2">
                            <hr className="mt-2" />
                            <div className="d-flex justify-content-between ">
                              <div className="">
                                <p className="mb-0 x-small">
                                  Follow us on social media
                                </p>
                              </div>
                              <div className="social-icon mb-2 text-end">
                                <a
                                  target="_blank"
                                  href="https://x.com/unitronix_corp"
                                  rel="noreferrer"
                                  className=""
                                >
                                  <img
                                    src="assets/images/icon/twitter.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://medium.com/@unitronixcorp"
                                  className=""
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/medium.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://www.youtube.com/@UnitronixCorp"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/youtube.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://discord.gg/unitronix"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/discord.svg"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                    <NavDropdown
                      title="Use"
                      id="basic-nav-dropdown"
                      className="customDropdown"
                    >
                      <div className="d-xl-flex justify-content-between p-2 gap-3">
                        <div className="menuBoxImg ">
                          <div className="megaImg">
                            <img src="assets/images/megamenu/m2.svg" alt="" />
                          </div>
                        </div>
                        <div className="menuContent">
                          <div className="d-flex gap-3">
                            <div className="menuBox ">
                              <NavDropdown.Item
                                href={`${config.baseUrl}portfolio`}
                              >
                                Cryptocurrency Portfolio
                              </NavDropdown.Item>
                              <NavDropdown.Item href="">
                                Unitronix Matrix
                                <div>
                                  <span class="text-grey x-small">
                                    (Coming Soon)
                                  </span>
                                </div>
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${config.baseUrl}howitwork`}
                              >
                                How It Works
                              </NavDropdown.Item>
                              <NavDropdown.Divider />
                            </div>
                            <div className="menuBox ">
                              <NavDropdown.Item href="">
                                RWAs Tokenization
                                <div>
                                  <span class="text-grey x-small">
                                    (Coming Soon)
                                  </span>
                                </div>
                              </NavDropdown.Item>
                              <NavDropdown.Item href="">
                                Intellectual Property
                                <div>
                                  <span class="text-grey x-small">
                                    (Coming Soon)
                                  </span>
                                </div>
                              </NavDropdown.Item>
                              <NavDropdown.Item href="">
                                Token
                                <div>
                                  <span class="text-grey x-small">
                                    (Coming Soon)
                                  </span>
                                </div>
                              </NavDropdown.Item>
                            </div>
                          </div>

                          <div className="megafooter px-2">
                            <hr className="mt-2" />
                            <div className="d-flex justify-content-between ">
                              <div className="">
                                <p className="mb-0 x-small">
                                  Follow us on social media
                                </p>
                              </div>
                              <div className="social-icon mb-2 text-end">
                                <a
                                  target="_blank"
                                  href="https://x.com/unitronix_corp"
                                  rel="noreferrer"
                                  className=""
                                >
                                  <img
                                    src="assets/images/icon/twitter.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://medium.com/@unitronixcorp"
                                  className=""
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/medium.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://www.youtube.com/@UnitronixCorp"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/youtube.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://discord.gg/unitronix"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/discord.svg"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>

                    <NavDropdown
                      title="Community"
                      id="basic-nav-dropdown"
                      className="customDropdown"
                    >
                      <div className="d-xl-flex justify-content-between p-2 gap-3">
                        <div className="menuBoxImg ">
                          <div className="megaImg">
                            <img src="assets/images/megamenu/m3.svg" alt="" />
                          </div>
                        </div>
                        <div className="menuContent">
                          <div className="d-flex gap-3">
                            <div className="menuBox ">
                              <NavDropdown.Item href={`${config.baseUrl}news`}>
                                News
                              </NavDropdown.Item>
                              <NavDropdown.Item href={`${config.baseUrl}blog`}>
                                Blog
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${config.baseUrl}contact`}
                              >
                                Get in Touch
                              </NavDropdown.Item>
                              <NavDropdown.Divider />
                            </div>
                            <div className="menuBox ">
                              <NavDropdown.Item
                                href="https://discord.gg/unitronix"
                                target="_blank"
                              >
                                Discord
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${config.baseUrl}podcast`}
                                target="_blank"
                              >
                                Podcast/YouTube
                              </NavDropdown.Item>
                            </div>
                          </div>

                          <div className="megafooter px-2">
                            <hr className="mt-2" />
                            <div className="d-flex justify-content-between ">
                              <div className="">
                                <p className="mb-0 x-small">
                                  Follow us on social media
                                </p>
                              </div>
                              <div className="social-icon mb-2 text-end">
                                <a
                                  target="_blank"
                                  href="https://x.com/unitronix_corp"
                                  rel="noreferrer"
                                  className=""
                                >
                                  <img
                                    src="assets/images/icon/twitter.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://medium.com/@unitronixcorp"
                                  className=""
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/medium.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://www.youtube.com/@UnitronixCorp"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/youtube.svg"
                                    alt=""
                                  />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://discord.gg/unitronix"
                                  rel="noreferrer"
                                >
                                  <img
                                    src="assets/images/icon/discord.svg"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </Nav>
                  <Form className="d-flex align-items-center">
                    {chain && (
                      <>
                        <div className="chainname">
                          {' '}
                          <span
                            style={{
                              display: 'inline-block',
                              width: '8px',
                              height: '8px',
                              backgroundColor: 'lightgreen',
                              borderRadius: '50%',
                              marginRight: '6px',
                              marginTop: '0px',
                            }}
                          ></span>
                          <span
                            style={{
                              className: 'me-xxl-3 ',
                              color: '#fff',
                              whiteSpace: 'nowrap',
                              marginRight: '40px',
                            }}
                          >
                            {isConnected ? chain.name.toString() : ''}
                          </span>
                        </div>
                      </>
                    )}
                    <Button
                      variant="primary"
                      className="text-black"
                      //onClick={(e) => handleConnectWallet(e)}
                    >
                      {isConnected
                        ? address.toString().substring(0, 4) +
                          '....' +
                          address
                            .toString()
                            .substring(address.length - 4, address.length)
                        : 'Coming Soon'}
                    </Button>
                  </Form>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </div>

      {/* ------Modal Utrx Dec Start------- */}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="border"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="p-4">
          <ModalDeck
            onSuccess={() => {
              setShow(false);
              handleDeck(new Event('click'));
            }}
          />
        </Modal.Body>
      </Modal>

      {/* ------Modal Utrx Dec End------- */}
    </>
  );
};

export default Header;
